import React from 'react'
import SearchPicker from '../common/SearchPicker'
import { formatDate } from '../../utils/functions'

const ChequePicker = (props) => {
    const { state } = props

    const option = (x) => <div>
        <label className='block'>Çek Sahibi : {x.owner} </label>
        <label className='block'>Tutar : {x.amount} {x.currency} </label>
        <label className='block'>Son Tarih : {formatDate(x.deadline)} </label>
        <label className='block'>Çek Numarası : {x.serialNumber} </label>
        <label className='block'>Banka : {x.bank} </label>
        <label className='block'>Şube : {x.branch} </label>
    </div>

    return (
        <SearchPicker
            {...props}
            value={state ? `${state?.owner}, ${state?.amount}, ${state.currency}` : ""}
            option={(x) => option(x)}
        />
    )
}

export default ChequePicker